export const EMPTY_STRING = "";
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_REQUIREMENTS_ICON_SIZE = 16;

export const fields = {
    CURRENT_PASSWORD: "Current password",
    NEW_PASSWORD: "New password",
    PASSWORD_CONFIRMATION: "Password confirmation",
    PASSWORD_SUBMIT: "Change Password",
    ENTER_PASSWORD: "Enter password",
};

export const messages = {
    SUCCESS: "Password validated.",
    EMPTY_CURRENT_PASSWORD: "Current password must be provided.",
    SAME_PASSWORD: "New password must be different from current password.",
};

export const buttonSize = {
    MEDIUM: "medium",
    LARGE: "large",
};

export const viewType = {
    TABLE_VIEW: "TableView",
    MINI_VIEW: "MiniView",
};

export const submitButtonText = {
    SUBMIT: "Submit",
    SIGN_UP: "Sign Up",
};

export const passwordRequirementsText = {
    MIN_LENGTH: "At least 8 characters in length",
    CHARACTER_TYPE_REQUIREMENTS:
        "Contain all of the following character types:",
    UPPERCASE: "Upper case letters (A-Z)",
    LOWERCASE: "Lower case letters (a-z)",
    NUMBER: "Numbers (0-9)",
    SPECIAL_CHAR: "Special characters (e.g. !@#$%^&*)",
};
